import axios from '../axios'

/* 
 * 订单模块
 */

// 保存
export const save = (data) => {
    return axios({
        url: '/order/save',
        method: 'post',
        data
    })
}
// 备注
export const note = (data) => {
    return axios({
        url: '/order/note',
        method: 'post',
        data
    })
}
// 删除
export const batchDelete = (data) => {
    return axios({
        url: '/order/delete',
        method: 'post',
        data
    })
}
// 查询
export const findPage = (data) => {
    return axios({
        url: '/order/findPage',
        method: 'post',
        data
    })
}
export const findPageAll = (data) => {
    return axios({
        url: '/order/findPageAll',
        method: 'post',
        data
    })
}
export const getStatus = (data) => {
    return axios({
        url: '/order/getStatus',
        method: 'post',
        data
    })
}
export const getNote = (data) => {
    return axios({
        url: '/order/getNote',
        method: 'post',
        data
    })
}
export const getFirst = (data) => {
    return axios({
        url: '/order/getFirst',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/moudules/order.js